import { FC, useCallback, useState } from 'react';
import { Collapse, Space, message } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Spinner } from 'components';
import { RightOutlined } from '@ant-design/icons';
// import LogoFPS from 'assets/images/logo-fps.svg';
import LogoBank from 'assets/images/bank.svg';
import LogoCheque from 'assets/images/cheque.svg';
import LogoPay from 'assets/images/claims/payonline.svg';

// import { PAYMENT_CONSTANTS } from '../utils';
import { useShortfallPaymentUrl } from 'all-in-one-shared-api';
import { getConfig } from 'configs';

import IconTitle from 'components/iconTitle/IconTitle';
// import { FPSPanelContent } from './FPSPanelContent';
import { ChequePanelContent } from './ChequePanelContent';
import { BankTransferContent } from './BankTransferContent';
import { SettleItem } from '../types';
import { useKeycloakReady } from 'hooks';
import { useGetSettleDescription } from '../utils';
import { localStorageService } from 'utils/LocalStorageService';
import { MessageType } from '../../../../models/MessageType';

const SpacingIconTitle = styled(IconTitle)`
  margin: 16px 0;
`;
const { Panel } = Collapse;
type OtherPaymentMethodsProps = {
  amount?: string;
  claims: SettleItem[];
};
const config = getConfig(process.env.REACT_APP_ENVIRONMENT ?? 'development');

export const OtherPaymentMethods: FC<OtherPaymentMethodsProps> = ({ claims }) => {
  const { t, i18n } = useTranslation();
  const { ready, token } = useKeycloakReady();
  const [navigating, setNavigating] = useState(false);
  const claimIdsStr = claims.map((c) => `${c.claimId}${c.sequenceNo ? '-' + c.sequenceNo : ''}`).join(',');
  const settleDescription = useGetSettleDescription(claimIdsStr);

  const { getShortfallPaymentUrl } = useShortfallPaymentUrl({
    accessToken: token || '',
    paymentShortfallDetailList: claims,
    description: settleDescription,
    paymentMethod: null,
    returnUrl: `${config.paymentReturnUrl}?claimId=${claimIdsStr}` || '',
    language: i18n.language == 'en' ? 'en' : 'tc',
    clientType: 'Web',
  });
  const gotoPay = useCallback(async () => {
    try {
      if (!(ready && settleDescription)) return;
      setNavigating(true);

      const data = await getShortfallPaymentUrl();
      if (!(data?.message && data?.referenceNo)) return;

      // store lastPayment info for redirection
      const lastPayment = JSON.stringify({
        claimId: claimIdsStr,
        referenceNo: data.referenceNo,
      });
      localStorageService.set('LastPayment', lastPayment);

      // navigate to payment gateway
      window.open(data?.message, '_self');
    } catch (err) {
      const error = (err as Error).toString();
      message[MessageType.ERROR](error.toString(), 5);
      setNavigating(false);
    }
  }, [ready, getShortfallPaymentUrl, settleDescription, claimIdsStr]);

  return navigating ? (
    <Spinner />
  ) : (
    <Space direction="vertical" style={{ display: 'flex' }}>
      <SpacingIconTitle title={t('claims.shortfall.otherPaymentMethods')} level={4} />

      <Collapse>
        <div className="ant-collapse-item" onClick={gotoPay} style={{ display: 'flex' }}>
          <div className="ant-collapse-header">
            <div className="ant-collapse-expand-icon">
              <RightOutlined className="ant-collapse-arrow " />
            </div>
            <IconTitle
              className="ant-collapse-header"
              title={t('shortfallPayment.otitle')}
              icon={LogoPay}
              level={5}
              iconStyle={{ width: '24px', height: '24px' }}
            />
          </div>
        </div>
        {/* <Panel
          collapsible="disabled"
          header={
            <div className="ant-collapse-item" onClick={gotoPay}>
              <IconTitle
                className="ant-collapse-header"
                title={t('shortfallPayment.fps.title')}
                icon={LogoFPS}
                level={5}
              />
            </div>
          }
          key="1"
        >
           <FPSPanelContent
            amount={amount}
            mcc={PAYMENT_CONSTANTS.FPS_MCC}
            currency={PAYMENT_CONSTANTS.FPS_CURRENCY}
            fpsId={PAYMENT_CONSTANTS.FPS_ID}
            merchantName={PAYMENT_CONSTANTS.MERCHANT_NAME}
            claims={claims}
          /> 
        </Panel>*/}
        <Panel
          header={<IconTitle title={t('shortfallPayment.bankTransfer.title')} icon={LogoBank} level={5} />}
          key="1"
        >
          <BankTransferContent />
        </Panel>
        <Panel header={<IconTitle title={t('shortfallPayment.cheque.title')} icon={LogoCheque} level={5} />} key="2">
          <ChequePanelContent />
        </Panel>
      </Collapse>
    </Space>
  );
};
